import { BaseDataModel } from "@domain/shared/types/BaseDataModel";

export class LabTest extends BaseDataModel {
	name: string = "";
	labName: string = "";
}
